import { getWithAuth } from './client';
import { apiVariables } from './apiVariables';
import type { appFieldSettingResponse } from '../../types/appConfig';

export const getAppFieldSetting = () =>
  getWithAuth<appFieldSettingResponse>(apiVariables.GetAppFieldSetting);
